var $ = require('jquery');

$.validator.addMethod("checkboxrequired", function (value, element, param) {
    return element.checked;
});

$.validator.unobtrusive.adapters.addBool("checkboxrequired");